import fs from 'node:fs'
import path from 'node:path'
import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import { snapshotTargetPath } from '@core-engine/snapshots/store/snapshot-target-path.js'

export function writeProjectFile(cwd: string, file: GeneratedFile): void {
  const outputPath = snapshotTargetPath(cwd, file.path)
  fs.mkdirSync(path.dirname(outputPath), { recursive: true })
  fs.writeFileSync(outputPath, file.content, 'utf-8')
}
